import React from 'react';
import { useDispatch } from 'react-redux';
import { setIsNewUser } from '../../features/auth/user.reducer';
import { consumePendingFirstSignupDemo } from '../../features/auth/firstSignupDemo';
import FirstLoginDemo from './FirstLoginDemo';

const DemoManager = ({ isNewUser }) => {
  const dispatch = useDispatch();
  const [showDemo, setShowDemo] = React.useState(() => {
    try {
      const storage = typeof window !== "undefined" ? window.sessionStorage : null;
      const hasPendingDemo = storage?.getItem("pendingFirstSignupDemo") === "true";
      return isNewUser || hasPendingDemo;
    } catch {
      return isNewUser;
    }
  });
  const [demoCompleted, setDemoCompleted] = React.useState(false);

  React.useEffect(() => {
    consumePendingFirstSignupDemo();
  }, []);

  function handleDemo() {
    if (showDemo === true) setShowDemo(1);
    if (showDemo === 1) setShowDemo(2);
    if (showDemo === 2) {
      setShowDemo(false);
      setDemoCompleted(true);
    }
    dispatch(setIsNewUser(false));
  }

  return {
    showDemo,
    demoCompleted,
    handleDemo,
    DemoComponent: showDemo ? (
      <FirstLoginDemo showDemo={showDemo} handleDemo={handleDemo} />
    ) : null
  };
};

export default DemoManager;
